import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import {
  Box,
  Chip,
  FormHelperTextProps,
  InputLabelProps,
  MenuItem,
  SelectProps,
  styled,
} from '@mui/material';
import { useFormikContext } from 'formik';
import { AnyARecord } from 'node:dns';
import FormikSelect from './FormikSelect';

interface Props extends Omit<SelectProps, 'value' | 'error'> {
  name: string;
  formHelperText?: FormHelperTextProps;
  inputLabel?: InputLabelProps;
  options: { id: number | string; name: string; disabled?: boolean }[];
}

export const FormikSelectMultipleWithContext = ({
  options,
  ...props
}: Props) => {
  const { values: formValues, setFieldValue } =
    useFormikContext<Record<string, AnyARecord>>();
  const handleDelete = (value: number | string) => {
    if (!(props.name in formValues)) {
      return;
    }
    const fieldValues = formValues[props.name];
    setFieldValue(
      props.name,
      Array.isArray(fieldValues)
        ? fieldValues.filter((option: any) => option !== value)
        : [],
    );
  };
  return (
    <FormikSelect
      {...props}
      MenuProps={{
        sx: {
          maxHeight: 300,
          maxWidth: 300,
        },
        MenuListProps: {
          sx: {
            li: {
              minHeight: 'auto',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'block',
            },
          },
        },
      }}
      multiple
      renderValue={(selected) => (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {(selected as (string | number)[])?.map((value) => (
            <StyledChip
              key={value}
              label={options?.find((p) => p.id === value)?.name}
              onDelete={() => handleDelete(value)}
              variant="filled"
              size="small"
              disabled={options?.find((p) => p.id === value)?.disabled}
              deleteIcon={
                <CancelOutlinedIcon
                  onMouseDown={(event) => event.stopPropagation()}
                />
              }
            />
          ))}
        </Box>
      )}
    >
      {options?.map((option) => (
        <MenuItem key={option.id} value={option.id} disabled={option.disabled}>
          {option.name}
        </MenuItem>
      ))}
    </FormikSelect>
  );
};

const StyledChip = styled(Chip)(
  ({ theme: { palette } }) => `
      height: 2rem;
      background-color: ${palette.primary.main};
      color: ${palette.white.main};
      svg {
          color: ${palette.white.main} !important;
      }
  `,
);
